/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .directive('blur', function () {
    return {
      restrict: 'A',
      link: blur
    };
  });

function blur(scope, element) {
  element.bind('click mouseup', function () {
    element.blur();
  });
}
